import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=dd2213da&scoped=true&"
import script from "./UserManage.vue?vue&type=script&lang=js&"
export * from "./UserManage.vue?vue&type=script&lang=js&"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=dd2213da&lang=less&scoped=true&"
import style1 from "./UserManage.vue?vue&type=style&index=1&id=dd2213da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2213da",
  null
  
)

export default component.exports